/*global Modernizr*/

export function isBrowser() {
    return typeof window === 'object';
}

export function isOnline() {
    //if browsers don't support navigator.onLine always return true. be happy :)
    return isBrowser() && 'onLine' in window.navigator ? window.navigator.onLine : true;
}

export function browserScrollPosition() {
    if (!isBrowser()) {
        return 0;
    }

    return (
        document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop
    );
}

export function isFullscreen() {
    if (!isBrowser()) {
        return false;
    }

    return document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.webkitCurrentFullScreenElement
        ? true
        : false;
}

export function supportsLocalStorage() {
    // No need to check for sessionStorage because same browser support as localstorage.
    return isBrowser() && Modernizr && Modernizr.localstorage;
}

export function supportsPeformanceApi(methods = []) {
    let supports = isBrowser() && window.hasOwnProperty('performance');

    if (supports) {
        supports = methods.some((method) => typeof window.performance[method] !== 'undefined');
    }

    return supports;
}

export function supportsNavigator(methods = []) {
    let supports = isBrowser() && window.hasOwnProperty('navigator');

    if (supports) {
        supports = methods.some((method) => typeof window.navigator[method] !== 'undefined');
    }

    return supports;
}

export function appIsHydrated() {
    if (!isBrowser()) {
        return false;
    }

    return window.APP_IS_HYDRATED === true;
}

export function isInSweden() {
    return typeof Modernizr !== 'undefined' && Modernizr.sweden === true;
}

export function isTouchDevice() {
    return typeof Modernizr !== 'undefined' && Modernizr.touchevents === true;
}
